import React, { useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Global from "../../util/Global";
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { LoaderComponent } from "../../util/Loader";
import NotFound from "../../components/NotFound";
import Pagination from "../../components/Pagination";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { AlertContext } from "../../util/Alerter";
import { SortTabCell } from "../../components/Utils";
import { Search as SearchIcon } from '@mui/icons-material';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton,
  TextField,
  Avatar,
  Tooltip
} from '@mui/material';

const AdminActualiteList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(true);
  const [newsList, setnewsList] = useState([]);
  const [paginatedItems, setpaginatedItems] = useState([])
  const { showAlert } = useContext(AlertContext)
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setfilteredItems] = useState([]);
  const [sortDirection, setSortDirection] = useState('desc');
  const [sortColumn, setSortColumn] = useState('date');
  const [sortedItems, setsortedItems] = useState([])

  const ACTUALITIES_URL = Global.backend + "/index.php/actualite/showall";
  const DELETE_ACTUALITY_URL = Global.backend + "/index.php/api/actualite/delete";

  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink({ path: "/dashboard/admin/adminactualiteadd", label: "news.addNews" })
    setpageTitle("navigation8.1")
    setalertTitle("")
    setnavLinks([])
  }, [])


  useEffect(() => {
    setisLoading(true)
    axios.get(ACTUALITIES_URL)
      .then((response) => {
        setnewsList(response.data);
      })
      .finally(() => {
        setisLoading(false);
      });
  }, []);





  const deleteNews = (actualiteId) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success ml-3",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: t("alertTitle.confirm"),
        text: t("deleteNews"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("alertButton.ok"),
        cancelButtonText: t("alertButton.cancel"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          setisLoading(true)
          axios.post(DELETE_ACTUALITY_URL, { actualiteId })
            .then(() => {
              showAlert("success", t("news.deletedNews"))
              setnewsList(newsList.filter(news => news.id != actualiteId))
            }).catch(() => {
              showAlert("error", t("request.deletedNews"))
            }).finally(() => {
              setisLoading(false)
            })
        }
      })
  }




  useEffect(() => {
    setfilteredItems(
      newsList.filter(news =>
        news.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        news.description.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, newsList]);

  useEffect(() => {
    const sortedMessages = [...filteredItems].sort((a, b) => {
      if (sortDirection === 'asc') {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
    });
    setsortedItems(sortedMessages)
  }, [sortDirection, sortColumn, filteredItems]);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };



  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading && (
        !newsList.length ? <NotFound /> :
          <div className="container-fluid">
            <div className="row">
              <div className="card">
                <div className="card-body">
                  <TextField
                    label="Search"
                    variant="outlined"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <IconButton>
                          <SearchIcon />
                        </IconButton>
                      ),
                    }}
                    fullWidth
                    margin="normal"
                  />


                  {!paginatedItems.length ? <NotFound /> :
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("news.image")}</TableCell>
                            <SortTabCell title={t("news.title")} label={"titre"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                            <SortTabCell title={t("news.publishDate")} label={"createdAt"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                            <TableCell>{t("action")}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {paginatedItems.map((news, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                <Avatar
                                  src={`${Global.backend}/uploads/${news.image}`}
                                  alt="News"
                                  sx={{ width: 100, height: 100 }}
                                >
                                  {news.titre[0]}
                                </Avatar>
                              </TableCell>
                              <TableCell>{news.titre}</TableCell>
                              <TableCell>{news.createdAt + " (" + moment(news.createdAt).fromNow() + ")"}</TableCell>
                              <TableCell>
                                <Tooltip title={t("edit")}>
                                  <IconButton
                                    color="primary"
                                    onClick={() => navigate("/dashboard/admin/adminactualityedit/" + news.id)}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={t("delete")}>
                                  <IconButton
                                    color="error"
                                    onClick={() => deleteNews(news.id)}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  }
                  <Pagination itemsPerPage={10} items={sortedItems} setItems={setpaginatedItems} />
                </div>
              </div>
            </div>
          </div>
      )
      }
    </LoaderComponent>
  )

  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading && (
        !newsList.length ? <NotFound /> :
          <div className="card">
            <div className="card-body">

              <div className="table-responsive mt-3">
                <table
                  className="table table-centered datatable dt-responsive nowrap "
                  style={{
                    borderCollapse: "collapse",
                    borderSpacing: "0",
                    width: "100%",
                  }}
                >
                  <thead className="thead-light">
                    <tr>
                      <th>{t("news.image")}</th>
                      <th>{t("news.title")}</th>
                      <th>{t("news.publishDate")}</th>
                      <th>{t("action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedItems.map((actuality, index) => (
                      <tr key={index}>
                        <td>
                          <img
                            src={`${Global.backend}/uploads/${actuality.image}`}
                            style={{ height: 100 }}
                          />
                        </td>
                        <td>{actuality.titre}</td>
                        <td>
                          {actuality.createdAt + " (" + moment(actuality.createdAt).fromNow() + ")"}
                        </td>


                        <td id="tooltip-container11">
                          <Tooltip title={t("edit")}>
                            <IconButton
                              color="primary"
                              onClick={() => navigate("/dashboard/admin/adminactualityedit/" + actuality.id)}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={t("delete")}>
                            <IconButton
                              color="error"
                              onClick={() => deleteNews(actuality.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>


                <Pagination itemsPerPage={10} items={newsList} setItems={setpaginatedItems} />
              </div>
            </div>
          </div>
      )}
    </LoaderComponent>
  );
};

export default AdminActualiteList;
